<span
    class="w-full overflow-hidden"
    [class]="{ disabled: disabled() }">
    <span
        class="flex justify-between items-center w-full px-2"
        [class.cursor-not-allowed]="disabled()"
        [class.cursor-pointer]="!disabled()"
        (click)="toggleExpansion()">
        <div class="flex items-center my-3 flex-1 min-w-0">
            <ng-content select="[header]" />
        </div>

        <fa-icon
            size="lg"
            [class]="`shrink-0 ml-2 mr-5 text-${chevronColor()}`"
            [class.expanded]="isExpanded()"
            [fixedWidth]="true"
            [icon]="['fas', 'chevron-down']" />
    </span>
    <div
        class="expansion-panel-content"
        [ngStyle]="contentStyle()">
        <ng-content select="[content]" />
    </div>
</span>
